import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import IPage from '../../interfaces/IPage';
import { Container } from './Loading.styles';

const Loading = (props: IPage) => {
  return (
    <Container>
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    </Container>
  );
};

export default Loading;
